import React from "react";
import { TableCell, TableBody, TableRow } from "@mui/material";

const cellStyle = {
  whiteSpace: "nowrap",
  py: 0.7,
  fontSize: "12px",
};
const inputStyle = {
  width: "100%",
  padding: "8px",
  textAlign: "center",
  border: "1px solid #dAdAdA",
  borderRadius: "25px",
  backgroundColor: "white",
  fontSize: "12px",
};

function UserManagementTableBody3({
  tableData,
  setTableData,
  handleInputChange,
}) {
  return (
    <TableBody>
      {tableData.rows?.map((row, rowIndex) => (
        <TableRow key={rowIndex}>
          <TableCell sx={{ ...cellStyle }}>{row?.factor}</TableCell>
          <TableCell sx={{ ...cellStyle }}>
            <input
              style={inputStyle}
              placeholder=""
              value={row?.lower}
              onChange={(e) => handleInputChange(e, rowIndex, "lower")}
            />
          </TableCell>
          <TableCell sx={{ ...cellStyle }}>
            <input
              style={inputStyle}
              placeholder=""
              value={row?.upper}
              onChange={(e) => handleInputChange(e, rowIndex, "upper")}
            />
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
}

export default UserManagementTableBody3;
